/**
 * ObjectId 유효성 확인
 * @param {string} id 
 */
 const _ObjectId = (id) => {
    return (id && id.length === 24) ? true : false
 }
 
 /**
  * 값이 null 또는 undefined 또는 ""가 아닌지 확인
  * @param {string} value 
  */
 const _NotEmpty = (value) => {
    return (value !== undefined && value !== null && value !== "")
 }
 
 const _Array = (arr) => {
    return (arr && arr instanceof Array)
 }

 /**
 * Array의 길이가 0보다 큰지 확인
 * @param {Array} arr
 */
const _ArrayNotEmpty = (arr) => {
   if (!_Array(arr)) return false
   return arr.length > 0
}
 
 /**
  * 배열 내 ID가 모두 유효한 ObjectId인지 확인
  * 하나라도 유효하지 않다면 false 반환
  * @param {string[]} idArray ObjectId 배열
  */
 const _ObjectIds = (idArray) => {
    if (!_Array(idArray)) return false
 
    for (let i = 0; i < idArray.length; ++i) {
       if (!_ObjectId(idArray[i])) return false
    }
    return true
 }

 /**
 * boolean 값인지 확인
 * @param {any} value 
 * @param {boolean} onlyBoolean false일 경우 string으로 'true' or 'false' 인것도 통과 
 * @returns 
 */
const _Boolean = (value, onlyBoolean = false) => {
   const type = typeof value
   if (type === 'boolean') 
       return true;
   else if (!onlyBoolean && type === 'string' && (value === 'true' || value === 'false'))
       return true;
   else 
       return false;
}

 export default {
    ObjectId: _ObjectId,
    NotEmpty: _NotEmpty,
    Array: _Array,
    ArrayNotEmpty: _ArrayNotEmpty,
    ObjectIds: _ObjectIds,
    Boolean: _Boolean
 }